// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[LightsController]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    const anEventManager = {
        createIObservableCallback(theCallback) {
            const aCallable = { callback: theCallback };
            return theModule.IObservableCallback.implement(aCallable);
        },
        addEventListener(theEventName, theCallback) {
            if (typeof theCallback === "function") {
                if (!theModule._myCallbacks[theEventName]) {
                    theModule._myCallbacks[theEventName] = [];
                }
                const aCallback = this.createIObservableCallback(theCallback);
                theModule._myCallbacks[theEventName].push(aCallback);
                theModule._cppSubscribe(theEventName, aCallback);
            }
            else {
                theModule._cppSubscribe(theEventName, theCallback);
            }
        },
        removeEventListener(theEventName, theCallback, theToClearData = true) {
            if (typeof theCallback === "function") {
                const aSubscriptionArray = theModule._myCallbacks[theEventName];
                if (!aSubscriptionArray) {
                    theModule.printErr("Callback to unsubscribe not found.");
                    return;
                }
                const anIdx = aSubscriptionArray.indexOf(theCallback);
                if (anIdx == -1) {
                    theModule.printErr("Callback to unsubscribe not found.");
                    return;
                }
                let aCallback = aSubscriptionArray.splice(anIdx, 1);
                theModule._cppUnsubscribe(theEventName, aCallback);
                aCallback.delete();
            }
            else {
                theModule._cppUnsubscribe(theEventName, theCallback);
                if (theToClearData) {
                    theCallback.delete();
                }
            }
        },
        emit(theEventName, theContext) { return theModule._cppEmit(theEventName, theContext); },
        addEvent(theEventName) {
            const anInstance = new theModule.Observable();
            theModule._cppAddEvent(theEventName, anInstance);
            anInstance.delete();
        },
        getEvent(theEventName) { return theModule._cppGetEvent(theEventName); },
        getLastMouseEventInfo() { return theModule._cppGetLastMouseEventInfo(); },
        onObjectMouseClick: (theObjectId, theSelectionId, theX, theY) => {
        }
    };
    theModule["_myEventManger"] = anEventManager;
});
